import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'az-root',
    encapsulation: ViewEncapsulation.None,
    template:`<router-outlet></router-outlet>`,
    styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'App Builder';
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/app.component.ts